import { media, spacing, color } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/postcss/lib/postcss.js";
import "../../node_modules/postcss-js/index.js";
import "../../node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const classNamePrefix = "umd-layout-background-highlight";
const box = {
  padding: `${spacing.md}`,
  borderLeft: `2px solid ${color.red}`,
  [`@media (${media.queries.tablet.min})`]: {
    padding: `${spacing.lg}`
  },
  [`@media (${media.queries.desktop.min})`]: {
    padding: `${spacing["3xl"]}`
  }
};
function composeHighlight(options) {
  const { color: bgColor = "white" } = options || {};
  let composed = {
    ...box
  };
  let className;
  let deprecatedAliases = [];
  if (bgColor === "white") {
    className = `${classNamePrefix}`;
    deprecatedAliases.push("umd-layout-background-box");
  } else if (bgColor === "light") {
    composed = {
      ...composed,
      backgroundColor: color.gray.lighter
    };
    className = `${classNamePrefix}-light`;
    deprecatedAliases.push("umd-layout-background-box");
  } else {
    composed = {
      ...composed,
      backgroundColor: color.gray.darker
    };
    className = `${classNamePrefix}-dark`;
    deprecatedAliases.push('umd-layout-background-box[theme="dark"]');
  }
  return objectWithClassName({
    ...composed,
    className: deprecatedAliases.length > 0 ? [className, ...deprecatedAliases] : className
  });
}
const white = composeHighlight({ color: "white" });
const light = composeHighlight({ color: "light" });
const dark = composeHighlight({ color: "dark" });
export {
  composeHighlight,
  dark,
  light,
  white
};
//# sourceMappingURL=highlight.js.map
